import React from 'react';

const Stocks = () => {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
      padding: '2rem 1rem',
    }}>
      <div className="page-wrapper">
        <div className="page-hero">
          <h1>📊 Stocks</h1>
          <p>Get insights into stock market analysis and trading.</p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}>
          <p>Stocks content will be rendered here</p>
        </div>
      </div>
    </div>
  );
};

export default Stocks;
